import factory from '../positions/asset-positions-factory';

import OptionsDerivativesAssetPositionDetails from './options-derivaties-asset-position-details';

export default factory({
  assetCategory: 'optionsDerivatives',

  ExpandedRowComponent: OptionsDerivativesAssetPositionDetails,
});
